import Header from './components/Header';
import Hero from './components/Hero';
import Ranking from './components/Ranking';
import Cards from './components/Cards';
import Updates from './components/Updates';
import IndexSection from './components/IndexSection';
import Comments from './components/Comments';
import Contact from './components/Contact';
import Faq from './components/Faq';
import Media from './components/Media';
import Topics from './components/Topics';
import About from './components/About';
import AppSection from './components/AppSection';
import Carousel from './components/Carousel';
import Features from './components/Features';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body">
      <Header />
      <main>
        <Hero />
        <Ranking />
        <Cards />
        <Updates />
        <IndexSection />
        <Comments />
        <Contact />
        <Faq />
        <Media />
        <Topics />
        <About />
        <AppSection />
        <Carousel />
        <Features />
      </main>
      <Footer />
    </div>
  );
}